import { getSegmentGroup, SegmentGroup } from '@fxtr/i18n';

/**
 * Whether the Tresor ID field should be shown for a garage segment.
 * Uses getSegmentGroup so new Motrio segments are picked up automatically.
 * Unknown/missing segments fail closed (hide the field).
 *
 * @param {string | null | undefined} segment
 * @returns {boolean}
 */
export function shouldShowTresorId(segment) {
  try {
    return Boolean(segment) && getSegmentGroup(segment) === SegmentGroup.MOTRIO;
  } catch {
    return false;
  }
}
